module.exports = __webpack_public_path__ + "img/recentl_ycreated.7c01bda1.svg";